import { notifyError, notifySuccess } from "@lib/helper"
import http from "../httpService"
import { L, LNotification } from "@lib/abpUtility"
import { PagedResultDto } from "@services/dto/pagedResultDto"

class ProjectFacilityService {
  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/ProjectFacility/GetAll", {
      params,
    })
    return res.data.result
  }
  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/ProjectFacility/Get", {
      params: { id },
    })
    const { result } = res.data
    return result
  }

  public async createOrUpdate(body: any) {
    const res = await http.post(
      "api/services/app/ProjectFacility/CreateOrUpdate",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )

    return res.data.result
  }
  public async activate(id: number, isActive) {
    const res = await http.post(
      "api/services/app/ProjectFacility/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }
  public async getList(params): Promise<any> {
    const res = await http.get("/api/services/app/ProjectFacility/GetList", {
      params,
    })
    const { result } = res.data

    return result
  }
}

export default new ProjectFacilityService()
